import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import EmployeeCard from "./employeeCard";
import firebase from "./firebase";

class AboutSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aboutDescription: "",
      employees: [
        // { id: "0", imgUrl: "", title: "Wasem Naser", text: "programer" },
      ]
    };
    this.getAboutDescription();
    this.getEmployees();
  }

  render() {
    return (
      <div className="text-light bg-dark p-3">
        <h1 align="center">About</h1>
        <h5 align="center" style={{}} className="text-secondary">
          {this.state.aboutDescription}
        </h5>
        <Row className="justify-content-md-center" around="xs">
          {this.state.employees.map(employee => (
            <Col md="auto " align="center">
              <EmployeeCard
                key={employee.id}
                employeeVal={employee}
                id={employee.id}
              ></EmployeeCard>
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  getAboutDescription = () => {
    var self = this;
    firebase
      .database()
      .ref("/Logo/")
      .on("value", function(snapshot) {
        console.log(snapshot.val());
        self.setState({ aboutDescription: snapshot.val().description });
      });
  };

  getEmployees = () => {
    var self = this;
    firebase
      .database()
      .ref("/Employees/")
      .on("value", function(snapshot) {
        snapshot.forEach(function(item) {
          self.setState({ employees: [...self.state.employees, item.val()] });
        });
        console.log(self.state.employees);
      });
  };
}

export default AboutSection;
